import { DefaultService } from '@/services/DefaultService';

export default class AcertoDespesaItemService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }
    
    find(id) {
        return this._http
        .get(`${this._env}/despesa/acerto-despesa-item/${id}.json`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    findAll(filtros) {
        return this._http
        .post(encodeURI(`${this._env}/despesa/acerto-despesa-item.json`), filtros, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    save(form) {
        return this._http
        .post(`${this._env}/despesa/acerto-despesa-item`, form, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    remove(uuiitem) {
        return this._http
        .get(`${this._env}/despesa/acerto-despesa-item/remove?uuiitem=${uuiitem}`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    findAllDespesasByAcerto(uuidacerto) {
        return this._http
        .get(`${this._env}/despesa/acerto-despesa-item/listbyuser.json?uuidacerto=${uuidacerto}`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    findAllFotosDespesasByDespesa(uuiddespesa) {
        return this._http
        .get(`${this._env}/despesa/acerto-despesa-item/fotos.json?uuiddespesa=${uuiddespesa}`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

}